import React from "react";
import { Route, Redirect } from "react-router-dom";

const VerifyRoute = ({ component: Component, props, isVerify, ...res }) => {
  return (
    <Route
      {...res}
      render={(props) => {
        return isVerify ? (
          <Component {...props} />
        ) : (
          <Redirect to={`/auth/sign_in`} />
        );
      }}
    />
  );
};

export default VerifyRoute;
